<script>
  export let rikContainer = undefined;
  export let portfolioContainer = undefined;
  export let contactContainer = undefined;
  export let mainHeight = 0;

  let scrollY = 0;
  let innerHeight = 0;

  function scrollTo(event, element) {
    event.preventDefault();

    const { top: bodyTop } = document.body.getBoundingClientRect();
    const { top } = element.getBoundingClientRect();

    window.scroll({ top: top - bodyTop, behavior: "smooth" });
  }

  function checkVisible(element) {
    if (!element) return false;

    const { top, bottom } = element.getBoundingClientRect();
    const middleOfScreen = innerHeight / 2;

    return top < middleOfScreen && bottom > middleOfScreen;
  }

  $: rikVisible = checkVisible(rikContainer, scrollY, innerHeight, mainHeight);
  $: portfolioVisible = checkVisible(
    portfolioContainer,
    scrollY,
    innerHeight,
    mainHeight
  );
  $: contactVisible = checkVisible(
    contactContainer,
    scrollY,
    innerHeight,
    mainHeight
  );
</script>

<style>
  nav {
    font-size: 1rem;
    line-height: 1;
    text-transform: uppercase;
    font-weight: 900;
    display: flex;
  }

  ul {
    display: flex;
    margin: 0 auto;
    padding: 0;
  }

  li {
    margin: 0;
    list-style: none;
  }

  li.active a {
    color: #fff;
  }

  li a {
    display: block;
    padding: 1.1875rem;
    color: var(--navigation-link-color);
  }

  li a:hover,
  li a:active {
    text-decoration: none;
  }
</style>

<svelte:window bind:scrollY bind:innerHeight />

<nav>
  <ul>
    <li class={rikVisible && 'active'}>
      <a on:click={event => scrollTo(event, rikContainer)} href="#rik">
        Wie is Rik?
      </a>
    </li>
    <li class={portfolioVisible && 'active'}>
      <a
        on:click={event => scrollTo(event, portfolioContainer)}
        href="#portfolio">
        Werk
      </a>
    </li>
    <li class={contactVisible && 'active'}>
      <a on:click={event => scrollTo(event, contactContainer)} href="#contact">
        Contact
      </a>
    </li>
  </ul>
</nav>
